// extracted by mini-css-extract-plugin
module.exports = {"Information":"Information__3MNZp","Veczor":"Veczor__TVdek"};